import {
  FDBodyText, FDHeadlineText, FDImage, FDLozenge, FDStack,
} from '@facet-wealth/design';
import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import { buildFacetDesignOverride, overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import MetaControl from 'Components/UI/Meta/MetaControl';
import {
  DataCardWithTruncation,
} from 'Views/Page/Content/Templates/WizardTemplates/ScenarioSelectionRedefined/ScenarioSelectionRedefinedTheYearAheadGoalStrategiesDetailsStep/Content/Common/DataCardWithTruncation';


const metaOverrides = buildFacetDesignOverride()
  .nameOverride(['title'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'sm' },
  }, overrideReadOnly)
  .nameOverride(['value'], {
    _component: () => FDHeadlineText,
    _customProps: { size: 'lg', color: 'textSecondary' },
  }, overrideReadOnly)
  .nameOverride(['valuePrompt'], {
    _component: () => FDBodyText,
    _customProps: { color: 'textSecondary' },
  }, overrideReadOnly);


export const PersonalizedStrategyDataCard = ({ resource }) => {
  return (
    <DataCardWithTruncation cardContent={resource.attr('description')} cardTitle={resource.attr('title')} test="personalized-strategy-data-card">
      <FDStack alignItems={'flex-start'} justifyContent={'space-between'} spacing={1}>
        <MetaControl resource={resource} attrName={'title'} metaOverrideSet={metaOverrides} flex={1} />
        {resource.withRelationship(fr.relationships.image.name,
          (rel) => <FDImage alt={''} width={32} height={32} src={rel.link('related').url()} rounded={false} />,
          () => null)}
      </FDStack>
      <FDStack direction={'row'} spacing={1} wrap>
        {resource.attr('lozenges')?.resources().list().map((is) => (<FDLozenge key={is.id()} label={is.attr('name')} color={is.attr('status')} />))}
      </FDStack>
      <FDStack spacing={1} alignItems={'center'}>
        <MetaControl resource={resource} attrName={'value'} metaOverrideSet={metaOverrides} />
        <MetaControl attrName={'valuePrompt'} resource={resource} metaOverrideSet={metaOverrides} />
      </FDStack>
      <MetaControl resource={resource} attrName={'description'} metaOverrideSet={metaOverrides} />
    </DataCardWithTruncation>
  );
};

PersonalizedStrategyDataCard.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
